import { forEachWithGitYield } from '../git/git-runtime.js';
import { gitCommitAllIfDirty } from '../git/branches/commit-and-push.js';

export async function commitSessionWorktrees(options: {
  paths: string[];
  branch: string;
  message: string;
  push: boolean;
}): Promise<{ ok: boolean; error?: string }> {
  const { paths, branch, message, push } = options;
  try {
    await forEachWithGitYield(paths, async (wt) => {
      await gitCommitAllIfDirty(wt, message, { push, branch });
    });
    return { ok: true };
  } catch (e) {
    const err = e instanceof Error ? e.message : String(e);
    return { ok: false, error: err };
  }
}
